import type { ASPRefreshUserInfoResponse, LoginInfo, MemberLoginResponse } from '@module/apis/client-side/member/type';
import { memberQueryKeys } from '@module/queries/member/memberQueryKeys';
import type { QueryClient } from '@tanstack/react-query';

// 업데이트된 최신 loginInfo 반영
export function syncLoginInfoQueryData(queryClient: QueryClient, freshLoginInfo: LoginInfo) {
  queryClient.setQueryData<MemberLoginResponse | undefined>(
    memberQueryKeys.fetchMemberLoginInfo().queryKey,
    (previousLoginInfo) => {
      if (!previousLoginInfo) return previousLoginInfo;

      return {
        ...previousLoginInfo,
        loginInfo: freshLoginInfo,
      };
    },
  );

  queryClient.setQueryData<ASPRefreshUserInfoResponse | undefined>(
    memberQueryKeys.fetchASPRefreshUserInfo().queryKey,
    (oldData) => {
      if (!oldData) return oldData;

      return {
        ...oldData,
        loginInfo: freshLoginInfo,
        coinHave: freshLoginInfo.userInfo.coinHave,
      };
    },
  );
}
